/**
 * Created by tofael on 1/3/18.
 */
import React from 'react';
import Dialog from 'material-ui/Dialog';

import TextField from 'material-ui/TextField';
import FlatButton from 'material-ui/FlatButton';

const CommentDialog = ({open, onChange, title, comment, onSubmit, toggleDialog}) => {
  const actions = [
    <FlatButton
      label="Submit"
      primary={true}
      onTouchTap={onSubmit} />,
    <FlatButton
      label="Cancel"
      onTouchTap={toggleDialog} />
  ];

  return (
    <div>
      <Dialog
        open={open}
        modal={false}
        actions={actions}
        title={title}
        autoScrollBodyContent={true}
        onRequestClose={toggleDialog} >

        <div>
        <TextField
          underlineShow={true}
          required={true}
          fullWidth={true}
          multiLine={true}
          rows={3}
          value={comment}
          floatingLabelText="Comment"
          onChange={onChange.bind(null, 'comment')}/><br/><br/>
        </div>
      </Dialog>
    </div>
  );
};

export default CommentDialog;


// WEBPACK FOOTER //
// ./src/screens/mission-view/comment-dialog.js